import { decryptData } from "@/lib/crypto";
import { sidebarMenuType } from "Types/LayoutDataType";
import { useUserData } from "helper/UserData";
import Cookies from "js-cookie";



export async function getSidebarMenuFromRedis(): Promise<sidebarMenuType[]> {
  return []
}

export const MenuList: sidebarMenuType[] = [
  {
    title: "SPA",
    menucontent: "SPA",
    Items: [

      {
        title: "Sample Page",
        icon: "sample-page",
        id: 28,
        type: "sub",
        pathSlice: "general",
        active: false,
        children: [
          { path: "/sample-page", title: "Sample Page", type: "link" },
        ],
      },
      {
        id: 33,
        path: "/support_ticket",
        icon: "support-tickets",
        type: "link",
        active: false,
        title: "Support Ticket",
      },
    ],
  },
];
